import React, { useState, useEffect } from 'react';
import {createUserWithEmailAndPassword,
onAuthStateChanged,
signOut} from "firebase/auth";
import {auth} from "../firebase-config";
import {db} from "../firebase-config";
import {app} from "../firebase-config";
import { collection, getDocs, addDoc, updateDoc, deleteDoc, doc, Firestore, query, where } from "firebase/firestore";
import { async } from '@firebase/util';


// export default class SignUp extends Component {
const SignUp = () => {
    
    const [registerEmail,setRegisterEmail] = useState("");
    const [registerPassword,setRegisterPassword] = useState("");

    const [registerName,setRegisterName] = useState("");
    const [registerLastname,setRegisterLastname] = useState("");
  
    const [users,setUsers] = useState([]);
    const [user,setUser] = useState({});
    const usersCollectionRef = collection(db,"users");

    const getUsers = async () => {
      const data = await getDocs(usersCollectionRef);
      setUsers(data.docs.map((doc)=> ({...doc.data(), id: doc.id})))
      console.log(data);
    }

    useEffect(() => {
      onAuthStateChanged(auth, (currentUser) => {
        setUser(currentUser);
        // console.log(user);
      });
      
      getUsers();
    }, []) 
    
    const register = async () => {
      try{
        const user = await createUserWithEmailAndPassword(auth,registerEmail,registerPassword).then((res) => {
          console.log('User account created & signed in!', res.user.uid);
          createUser(res.user.uid);
        });
        console.log(user);
      } catch (error){
        console.log(error.message);
      }
    };

    const delete_user = async (id) => {
      let userid = "";
      const q = query(usersCollectionRef,where("id", "==", id));
      const querySnapshot = await getDocs(q).then((res) => {
        res.forEach((doc) => {
          // doc.data() is never undefined for query doc snapshots
          userid = doc.id
        });
        alert(userid);
        return;
        user.delete().then(function() {
          deleteUser(userid);
          alert("user deleted");
        }).catch(function(error) {
          console.log(error.message);
        });
      });
    }

    const logout = async () => {
      await signOut(auth);
    };

    const createUser = async (uid) => {
      try{
        const userData = await addDoc(usersCollectionRef,{name:registerName,lastname:registerLastname,email:registerEmail,password:registerPassword,id: uid})
        console.log(userData)
        getUsers();
      } catch (error) {
        console.log(error.message)
      }
    }

    const updateUser = async (id, age) => {
      const userDoc = doc(db, "users", id);
      const newFields = { age: age + 1 };
      await updateDoc(userDoc, newFields);
      getUsers();
    };

    const deleteUser = async (id) => {
      const userDoc = doc(db, "users", id);
      await deleteDoc(userDoc);
      getUsers();
    };

    let button;
    if (user!=null) {
      button = <button onClick={() => {delete_user(user.uid)}} className="btn btn-danger">delete user</button>
    } else {
      button = "";
    }


    return (
        <div className="auth-wrapper">
          <div className="auth-inner">
        <h3>Sign Up { (user!=null) ? user.email: "" }</h3>
        <div className="mb-3">
          <label>First name</label>
          <input
            type="text"
            className="form-control"
            placeholder="First name"
            value={registerName}
            onChange={(event)=>{setRegisterName(event.target.value)}}
          />
        </div>

        <div className="mb-3">
          <label>Last name</label>
          <input 
            type="text" 
            className="form-control" 
            placeholder="Last name"
            value={registerLastname}
            onChange={(event)=>{setRegisterLastname(event.target.value)}}
          />
          
        </div>

        <div className="mb-3">
          <label>Email address</label>
          <input
            type="email"
            className="form-control"
            placeholder="Enter email"
            value={registerEmail}
            onChange={(event)=>{setRegisterEmail(event.target.value)}}
          />
        </div>

        <div className="mb-3">
          <label>Password</label>
          <input
            type="password"
            className="form-control"
            placeholder="Enter password"
            value={registerPassword}
            onChange={(event)=>{setRegisterPassword(event.target.value)}}
          />
        </div>
        <div className="d-grid">
        <button onClick={register} className="btn btn-primary">
            Sign Up
          </button>
          <button onClick={logout} className="btn btn-danger">
            Sign Out
          </button>
          {button}
        </div>
        <p className="forgot-password text-right">
          Already registered <a href="/sign-in">sign in?</a>
        </p>
        <div>
          {users.map((user) => {
            return(
              <div key={user.id}>
                {" "}
                <h1>Name:{user.name}</h1>
                <h1>Lastname:{user.lastname}</h1>
                <h1>Email:{user.email}</h1>
                <h1>Password:{user.password}</h1>
                <button
                  onClick={() => {
                    updateUser(user.id, user.age);
                  }}
                >
                  {" "}
                  Increase Age
                </button>
                <button
                  onClick={() => {
                    deleteUser(user.id);
                  }}
                >
                  {" "}
                  Delete User
                </button>
              </div>
            );
          })}
        </div>
      </div>
      </div>
    )
}

export default SignUp;